import React from "react";
import PageWrapper from "../components/PageWrapper";

export default function HowToBuy() {
  return (
    <PageWrapper>
      <div
        style={{
          maxWidth: "900px",
          margin: "auto",
          borderRadius: "32px",
          padding: "32px 18px",
          background: "rgba(0,0,0,0.10)",
          boxSizing: "border-box"
        }}
      >
        <h1 style={{
          fontSize: "2em",
          color: "#FFD700",
          fontWeight: "bold",
          marginBottom: "18px"
        }}>How to Buy MONKZI</h1>

        <ol style={{
          color: "#fff",
          fontSize: "1.08em",
          marginBottom: "24px",
          lineHeight: "1.7"
        }}>
          <li><b>Install MetaMask</b> (or Trust Wallet) on your phone/PC.</li>
          <li>Buy USDT and send it to your BNB Chain wallet.</li>
          <li>Go to <a href="https://pancakeswap.finance/swap?inputCurrency=0x55d398326f99059fF775485246999027B3197955&outputCurrency=0x3799f998A13BC157e42020305eA4a81Bd3eC3d6a" target="_blank" rel="noopener noreferrer" style={{ color: "#FFD700" }}>PancakeSwap</a>.</li>
          <li>connect your wallet</li>
          <li>Click on Swap Button</li>
          <li>Done! View your MONKZI in wallet (import token if needed).</li>
        </ol>

        <div style={{
          color: "#FFD700",
          marginTop: "18px",
          fontWeight: "bold"
        }}>
          Need help? DM us on <a href="https://t.me/monkillaofficial" style={{ color: "#0088cc" }}>Telegram</a>
        </div>
      </div>
      <style>{`
        @media (max-width: 700px) {
          .page-card {
            min-width: 92vw !important;
            max-width: 99vw !important;
            padding: 18px 5vw !important;
          }
        }
      `}</style>
      {/* --- HOW TO BUY BANNER --- */}
        <div
          style={{
            margin: "18px 0 26px 0",
            fontWeight: "bold",
            color: "#FFD700",
            background: "rgba(20,30,40,0.63)",
            borderRadius: "19px",
            padding: "18px",
            fontSize: "1.05em",
            boxShadow: "0 4px 24px rgba(0,0,0,0.06)",
            textAlign: "center"
          }}
        >
          Buy, sell, or hold MONKZI easily—no lockups, no tricks. Each transaction is limited to <b>10,000,000 tokens</b>, and every wallet can hold up to <b>20,000,000</b> to ensure fairness and reward loyal community members. Join the journey and let Monkzi take you to the moon!
        </div>
        {/* --- SOCIAL LINKS --- */}
        <div style={{
          marginTop: "38px",
          borderTop: "1.5px solid #404040",
          padding: "24px 0 8px 0",
          textAlign: "center"
        }}>
          <span style={{ fontWeight: "bold", marginRight: "18px", color: "#FFD700" }}>Follow us:</span>
          <a href="https://t.me/monkillaofficial" target="_blank" rel="noopener noreferrer" style={{ color: "#0088cc", margin: "0 14px", fontWeight: "bold" }}>Telegram</a>
          <a href="https://twitter.com/monkillacoin" target="_blank" rel="noopener noreferrer" style={{ color: "#1da1f2", margin: "0 14px", fontWeight: "bold" }}>X (Twitter)</a>
          <a href="https://instagram.com/monkilla.official" target="_blank" rel="noopener noreferrer" style={{ color: "#d6249f", margin: "0 14px", fontWeight: "bold" }}>Instagram</a>
          <a href="https://www.facebook.com/profile.php?id=61578002207190" target="_blank" rel="noopener noreferrer" style={{ color: "#d6249f", margin: "0 14px", fontWeight: "bold" }}>Facebook</a>
		<a href="https://discord.gg/q8MDWV4K" target="_blank" rel="noopener noreferrer" style={{ color: "#d6249f", margin: "0 14px", fontWeight: "bold" }}>Discord</a>
          <a href="mailto:info@monkilla.com" style={{ color: "#FFD700", margin: "0 14px", fontWeight: "bold" }}>Email</a>
        </div>
    </PageWrapper>
  );
}
